import React, { useEffect, useState, useContext, useRef } from "react";
import { GlobalContext } from "../contexts/GlobalContext";
import { useLocation, useParams } from "react-router-dom";
import {
	PiPencilSimple,
	PiShieldCheckeredLight,
	PiMaskHappyLight,
	PiTrash,
} from "react-icons/pi";
import EditRole from "./EditRole";
import client from '../client';
import { createDialog, ListItem, ContentGroup, ContentContainer } from 'coaz-ui';

const Role = () => {
	const { version,setVersion } = useContext(GlobalContext);
	const [role, setRole] = useState(null);
	const [buttons, setButtons] = useState([]);
	const [loading, setLoading] = useState(true);
	const [itemButtons, setItemButtons] = useState(null);
	const { request, getCurrent} = client;
	const { roleId } = useParams();
	const path = useLocation().pathname;

	const onEdit = (e) => {
		e.preventDefault();
		createDialog({
            title:"Edit Role",
            Component:EditRole,
			params:{id:roleId},
            version:version,
            setVersion:setVersion
        })
	};

	const getRole = async () => {
		setLoading(true);

		let curr = await getCurrent();

		if (!curr) {
			return;
		}

		let updateAuth = curr.authorities.find((auth) => {
			return auth.authority === "ROLE:UPDATE";
		});
		if (updateAuth) {
			setItemButtons([
				{
					name: "Remove",
					Icon: PiTrash,
				},
			]);
		}

		if (roleId) {
			await request("GET", `roles/${roleId}`)
				.then((response) => {
					if (response && response.ref) {
						setRole(response);
						if (!response.reserved && updateAuth) {
							setButtons([
								{
									Icon: PiPencilSimple,
									name: "Edit",
									handler: onEdit,
								},
							]);
						}
					} else {
						setRole(null);
					}
				})
				.catch((error) => {
					setRole(null);
				});
		}
		setLoading(false);
	};

	useEffect(() => {
		getRole();
	}, [path, version]);

	return (
		<ContentContainer
			buttons={buttons}
			Icon={PiMaskHappyLight}
			text={role ? role.name : ""}
			scrollable={true}
			background={true}
			loading={loading}
		>
			{role && role.authorities && role.authorities.length > 0 && (
				<ContentGroup name="Authorities">
					{role.authorities.map((authority, i) => (
						<ListItem
							key={i}
							Icon={PiShieldCheckeredLight}
							item={{ text: authority }}
						/>
					))}
				</ContentGroup>
			)}
		</ContentContainer>
	);
};

export default Role;
